import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Grid,
  Card,
  CardHeader,
  Alert,
  CircularProgress,
  Chip,
  Stack,
  Divider,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Breadcrumbs,
  Link,
  FormControl,
  FormControlLabel,
  Switch,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Link as LinkIcon,
  Image as ImageIcon,
} from '@mui/icons-material';
import { NewsFeedDetail as NewsFeedDetailType } from '../../types/newsfeed';
import { getNewsfeedById, deleteNewsfeed } from '../../endpoints/newsfeedTs';
import { hasPermission } from '../../utils/permissions';
import ChapterSelector from '../../Components/ChapterSelector';
import { useApiSend, useApiGet } from '../../utils/httpClientTs';
import ReactPlayer from 'react-player';

// Mock data for testing - similar to NewsfeedList.tsx (commented out since we're using API)
// const mockNewsFeedDetails: Record<string, NewsFeedDetailType> = {
//   '1': {
//     id: '1',
//     title: 'Welcome to PEO Foundation',
//     description: 'A comprehensive introduction to the PEO Foundation and its mission to support education and empower women.',
//     image_url: 'https://via.placeholder.com/400x200/1976d2/ffffff?text=PEO+Foundation',
//     created_at: '2024-01-15T10:00:00Z',
//     link_url: 'https://peofoundation.org',
//     start_date: '2024-01-15',
//     end_date: '2024-12-31',
//     is_active: true,
//     local_chapter_id: null,
//     spd_chapter_id: null,
//     is_international: true,
//     sections: [
//       {
//         id: 'section-1',
//         title: 'About PEO Foundation',
//         order: 1,
//         content: [
//           {
//             id: 'content-1',
//             content_type_id: '60308536096c4ce088bee75af7ae8ae2',
//             content_type: 'paragraph',
//             title: null,
//             list: null,
//             paragraph: 'The PEO Foundation is dedicated to promoting educational opportunities for women through scholarships, grants, and other financial assistance programs. Our mission is to empower women to achieve their educational goals and make a positive impact in their communities.',
//             order: 1,
//           },
//           {
//             id: 'content-2',
//             content_type_id: 'c1e257bc8c674ae28a7b2085518aea9e',
//             content_type: 'list',
//             title: 'Key Programs',
//             list: [
//               { id: 'item-1', content: 'Educational Scholarships', order: 1 },
//               { id: 'item-2', content: 'Professional Development Grants', order: 2 },
//               { id: 'item-3', content: 'Community Service Initiatives', order: 3 },
//               { id: 'item-4', content: 'Leadership Training Programs', order: 4 },
//             ],
//             paragraph: null,
//             order: 2,
//           },
//         ],
//       },
//       {
//         id: 'section-2',
//         title: 'Getting Started',
//         order: 2,
//         content: [
//           {
//             id: 'content-3',
//             content_type_id: '60308536096c4ce088bee75af7ae8ae2',
//             content_type: 'paragraph',
//             title: null,
//             list: null,
//             paragraph: 'To get started with PEO Foundation, explore our programs, review eligibility requirements, and submit your application. Our team is here to support you every step of the way.',
//             order: 1,
//           },
//         ],
//       },
//     ],
//   },
//   '2': {
//     id: '2',
//     title: 'Annual Chapter Meeting Announcement',
//     description: 'Important information about the upcoming annual chapter meeting and registration details.',
//     image_url: 'https://via.placeholder.com/400x200/2e7d32/ffffff?text=Chapter+Meeting',
//     created_at: '2024-02-01T09:00:00Z',
//     link_url: 'https://peofoundation.org/meeting',
//     local_chapter_id: 'chapter-1',
//     spd_chapter_id: null,
//     is_international: false,
//     start_date: '2024-02-01',
//     end_date: '2024-03-01',
//     is_active: true,
//     sections: [
//       {
//         id: 'section-1',
//         title: 'Meeting Details',
//         order: 1,
//         content: [
//           {
//             id: 'content-1',
//             content_type_id: 'c1e257bc8c674ae28a7b2085518aea9e',
//             content_type: 'list',
//             title: 'Event Information',
//             list: [
//               { id: 'item-1', content: 'Date: February 28, 2024', order: 1 },
//               { id: 'item-2', content: 'Time: 9:00 AM - 5:00 PM', order: 2 },
//               { id: 'item-3', content: 'Location: PEO Foundation Headquarters', order: 3 },
//               { id: 'item-4', content: 'Theme: "Empowering Women Through Education"', order: 4 },
//             ],
//             paragraph: null,
//             order: 1,
//           },
//         ],
//       },
//     ],
//   },
//   '3': {
//     id: '3',
//     title: 'Professional Development Workshop',
//     description: 'Join us for an intensive workshop focused on professional growth and skill development.',
//     image_url: 'https://via.placeholder.com/400x200/ed6c02/ffffff?text=Workshop',
//     created_at: '2024-03-01T14:00:00Z',
//     link_url: 'https://peofoundation.org/workshop',
//     local_chapter_id: null,
//     spd_chapter_id: 'spd_chapter_id: 'spd-1',
//     is_international: false,
//     start_date: '2024-03-01',
//     end_date: '2024-04-01',
//     is_active: true,
//     sections: [
//       {
//         id: 'section-1',
//         title: 'Workshop Agenda',
//         order: 1,
//         content: [
//           {
//             id: 'content-1',
//             content_type_id: '60308536096c4ce088bee75af7ae8ae2',
//             content_type: 'paragraph',
//             title: null,
//             list: null,
//             paragraph: 'This comprehensive workshop will cover essential professional skills including leadership, communication, networking, and strategic planning. Participants will leave with actionable strategies for career advancement.',
//             order: 1,
//           },
//         ],
//       },
//     ],
//   },
// };

export default function NewsFeedDetail(): React.JSX.Element {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [newsfeed, setNewsfeed] = useState<NewsFeedDetailType | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState<NewsFeedDetailType | null>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  // Check permissions
  const canEdit = hasPermission('NEWSFEED_EDIT');
  const canDelete = hasPermission('NEWSFEED_DELETE');

  // API hooks
  const { data: newsfeedData, isLoading } = useApiGet(
    ['newsfeed', id],
    () => getNewsfeedById(id!),
    { enabled: !!id }
  );

  const { mutate: updateNewsfeed, isPending: isSaving } = useApiSend(
    (data: { id: string; data: Partial<NewsFeedDetailType> }) =>
      updateNewsfeed(data),
    (data) => {
      setNewsfeed(data);
      setEditData(data);
      setIsEditing(false);
    },
    (error) => {
      console.error('Error updating newsfeed:', error);
    }
  );

  const { mutate: deleteNewsfeedMutation, isPending: isDeleting } = useApiSend(
    deleteNewsfeed,
    () => {
      setShowDeleteDialog(false);
      navigate('/newsfeed');
    },
    (error) => {
      console.error('Error deleting newsfeed:', error);
    }
  );

  // Update local state when API data changes
  useEffect(() => {
    if (newsfeedData) {
      console.log('NewsFeedDetail - Received newsfeed data:', newsfeedData);
      console.log('NewsFeedDetail - Data type check:', {
        hasSections: 'sections' in newsfeedData,
        sectionsType: typeof newsfeedData.sections,
        sectionsIsArray: Array.isArray(newsfeedData.sections),
        sectionsLength: newsfeedData.sections?.length,
        fullData: newsfeedData,
      });
      console.log('NewsFeedDetail - Sections:', newsfeedData.sections);
      console.log(
        'NewsFeedDetail - Sections length:',
        newsfeedData.sections?.length
      );
      if (newsfeedData.sections) {
        newsfeedData.sections.forEach((section, index) => {
          console.log(`NewsFeedDetail - Section ${index}:`, section);
          console.log(
            `NewsFeedDetail - Section ${index} content:`,
            section.content
          );
        });
      }
      setNewsfeed(newsfeedData);
      setEditData(newsfeedData);
    }
  }, [newsfeedData]);

  const handleEdit = () => {
    setIsEditing(true);
    setEditData(newsfeed);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditData(newsfeed);
  };

  const handleSave = () => {
    if (!editData || !id) return;

    // Use the API mutation hook
    updateNewsfeed({ id, data: editData });
  };

  const handleDelete = () => {
    if (!id) return;

    // Use the API mutation hook
    deleteNewsfeedMutation(id);
  };

  const handleInputChange = (
    field: keyof NewsFeedDetailType,
    value: string | boolean
  ) => {
    if (editData) {
      setEditData({ ...editData, [field]: value });
    }
  };

  // const handleChapterSelect = (field: 'local_chapter_id' | 'spd_chapter_id', value: string | null) => {
  //   if (editData) {
  //     setEditData({ ...editData, [field]: value });
  //   }
  // };

  const handleSectionTitleChange = (sectionId: string, title: string) => {
    if (editData) {
      setEditData({
        ...editData,
        sections: editData.sections.map((section) =>
          section.id === sectionId ? { ...section, title } : section
        ),
      });
    }
  };

  const handleContentChange = (
    sectionId: string,
    contentId: string,
    field: string,
    value: string
  ) => {
    if (editData) {
      setEditData({
        ...editData,
        sections: editData.sections.map((section) =>
          section.id === sectionId
            ? {
                ...section,
                content: section.content.map((content) =>
                  content.id === contentId
                    ? { ...content, [field]: value }
                    : content
                ),
              }
            : section
        ),
      });
    }
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!newsfeed) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Newsfeed not found. Please check the URL and try again.
        </Alert>
      </Box>
    );
  }

  const currentData = isEditing ? editData : newsfeed;

  return (
    <Box sx={{ p: 3 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <Link
          component="button"
          variant="body2"
          onClick={() => navigate('/newsfeed')}
          sx={{ cursor: 'pointer' }}
        >
          Newsfeeds
        </Link>
        <Typography color="text.primary">{newsfeed.title}</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Card elevation={3} sx={{ mb: 4 }}>
        <CardHeader
          title={
            <Typography variant="h4" component="h1" color="primary">
              {isEditing ? 'Edit Newsfeed' : newsfeed.title}
            </Typography>
          }
          subheader={
            <Typography variant="body1" color="text.secondary">
              {isEditing
                ? 'Make changes to the newsfeed content'
                : newsfeed.description}
            </Typography>
          }
          action={
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/newsfeed')}
                size="large"
              >
                Back to List
              </Button>
              {canEdit && !isEditing && (
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={handleEdit}
                  size="large"
                >
                  Edit
                </Button>
              )}
              {canDelete && (
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => setShowDeleteDialog(true)}
                  disabled={isDeleting}
                  size="large"
                >
                  Delete
                </Button>
              )}
            </Stack>
          }
        />
      </Card>

      {/* Edit Actions */}
      {isEditing && (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              startIcon={<CancelIcon />}
              onClick={handleCancelEdit}
              disabled={isSaving}
              size="large"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={
                isSaving ? <CircularProgress size={20} /> : <SaveIcon />
              }
              onClick={handleSave}
              disabled={isSaving}
              size="large"
            >
              {isSaving ? 'Saving...' : 'Save Changes'}
            </Button>
          </Stack>
        </Paper>
      )}

      {/* Main Content */}
      <Grid container spacing={3}>
        {/* Left Column - Main Content */}
        <Grid item xs={12} lg={8}>
          {/* Basic Information */}
          <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Basic Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  value={currentData?.title || ''}
                  onChange={(e) => handleInputChange('title', e.target.value)}
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Description"
                  value={currentData?.description || ''}
                  onChange={(e) =>
                    handleInputChange('description', e.target.value)
                  }
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Image URL"
                  value={currentData?.image_url || ''}
                  onChange={(e) =>
                    handleInputChange('image_url', e.target.value)
                  }
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                  InputProps={{
                    startAdornment: (
                      <ImageIcon sx={{ mr: 1, color: 'text.secondary' }} />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Link URL"
                  value={currentData?.link_url || ''}
                  onChange={(e) =>
                    handleInputChange('link_url', e.target.value)
                  }
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                  InputProps={{
                    startAdornment: (
                      <LinkIcon sx={{ mr: 1, color: 'text.secondary' }} />
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Paper>

          {/* Newsfeed Settings */}
          <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Newsfeed Settings
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Start Date"
                  type="date"
                  value={currentData?.start_date || ''}
                  onChange={(e) =>
                    handleInputChange('start_date', e.target.value)
                  }
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="End Date"
                  type="date"
                  value={currentData?.end_date || ''}
                  onChange={(e) =>
                    handleInputChange('end_date', e.target.value)
                  }
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={currentData?.is_active || false}
                        onChange={(e) =>
                          handleInputChange('is_active', e.target.checked)
                        }
                        disabled={!isEditing}
                        color="primary"
                      />
                    }
                    label="Active"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={currentData?.is_international || false}
                        onChange={(e) =>
                          handleInputChange(
                            'is_international',
                            e.target.checked
                          )
                        }
                        disabled={!isEditing}
                        color="primary"
                      />
                    }
                    label="International"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <ChapterSelector
                  chapter={currentData?.local_chapter_id || null}
                  handleChapterSelect={(value) =>
                    handleInputChange('local_chapter_id', value)
                  }
                  spd={false}
                  reportId="newsfeed-detail"
                  label="Local Chapter"
                  all={true}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ChapterSelector
                  chapter={currentData?.spd_chapter_id || null}
                  handleChapterSelect={(value) =>
                    handleInputChange('spd_chapter_id', value)
                  }
                  spd={true}
                  reportId="newsfeed-detail"
                  label="SPD Chapter"
                  all={true}
                />
              </Grid>
            </Grid>
          </Paper>

          {/* Content Sections */}
          <Paper elevation={2} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Content Sections
            </Typography>
            {currentData?.sections && currentData.sections.length > 0 ? (
              currentData.sections.map((section, sectionIndex) => (
                <Box key={section.id} sx={{ mb: 4 }}>
                  <Divider sx={{ mb: 2 }} />
                  <TextField
                    fullWidth
                    label="Section Title"
                    value={section.title || ''}
                    onChange={(e) =>
                      handleSectionTitleChange(section.id, e.target.value)
                    }
                    disabled={!isEditing}
                    variant={isEditing ? 'outlined' : 'standard'}
                    sx={{ mb: 2 }}
                  />

                  {section.content.map((content, contentIndex) => (
                    <Box key={content.id} sx={{ mb: 3, pl: 2 }}>
                      {content.content_type_id ===
                      '60308536096c4ce088bee75af7ae8ae2' ? (
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          label="Paragraph Content"
                          value={content.paragraph || ''}
                          onChange={(e) =>
                            handleContentChange(
                              section.id,
                              content.id,
                              'paragraph',
                              e.target.value
                            )
                          }
                          disabled={!isEditing}
                          variant={isEditing ? 'outlined' : 'standard'}
                        />
                      ) : content.content_type_id ===
                        'fd9dd86a20e24e79b920e191f3b8203a' ? (
                        <Box>
                          <TextField
                            fullWidth
                            label="Video URL"
                            value={content.video_url || ''}
                            onChange={(e) =>
                              handleContentChange(
                                section.id,
                                content.id,
                                'video_url',
                                e.target.value
                              )
                            }
                            disabled={!isEditing}
                            variant={isEditing ? 'outlined' : 'standard'}
                            sx={{ mb: 2 }}
                          />
                          {content.video_url && (
                            <Box
                              sx={{ width: '100%', maxWidth: '600px', mb: 2 }}
                            >
                              <ReactPlayer
                                className="react-player"
                                width="100%"
                                height="300px"
                                url={content.video_url}
                                playsinline={true}
                                controls={true}
                                style={{
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                      ) : content.content_type_id ===
                        'c1e257bc8c674ae28a7b2085518aea9e' ? (
                        <Box>
                          <TextField
                            fullWidth
                            label="List Title"
                            value={content.title || ''}
                            onChange={(e) =>
                              handleContentChange(
                                section.id,
                                content.id,
                                'title',
                                e.target.value
                              )
                            }
                            disabled={!isEditing}
                            variant={isEditing ? 'outlined' : 'standard'}
                            sx={{ mb: 2 }}
                          />
                          {content.list?.map((item, itemIndex) => (
                            <Box
                              key={item.id}
                              sx={{
                                mb: 2,
                                p: 2,
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                              }}
                            >
                              <TextField
                                fullWidth
                                label={`List Item ${itemIndex + 1}`}
                                value={item.content}
                                onChange={(e) => {
                                  if (editData) {
                                    const newList = [...(content.list || [])];
                                    newList[itemIndex] = {
                                      ...item,
                                      content: e.target.value,
                                    };
                                    handleContentChange(
                                      section.id,
                                      content.id,
                                      'list',
                                      JSON.stringify(newList)
                                    );
                                  }
                                }}
                                disabled={!isEditing}
                                variant={isEditing ? 'outlined' : 'standard'}
                                sx={{ mb: 2 }}
                              />

                              {isEditing && (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={item.is_link || false}
                                        onChange={(e) => {
                                          if (editData) {
                                            const newList = [
                                              ...(content.list || []),
                                            ];
                                            newList[itemIndex] = {
                                              ...item,
                                              is_link: e.target.checked,
                                              link_url: e.target.checked
                                                ? item.link_url || ''
                                                : null,
                                            };
                                            handleContentChange(
                                              section.id,
                                              content.id,
                                              'list',
                                              JSON.stringify(newList)
                                            );
                                          }
                                        }}
                                        color="primary"
                                      />
                                    }
                                    label="Is Link"
                                  />
                                  {item.is_link && (
                                    <TextField
                                      fullWidth
                                      label="Link URL"
                                      value={item.link_url || ''}
                                      onChange={(e) => {
                                        if (editData) {
                                          const newList = [
                                            ...(content.list || []),
                                          ];
                                          newList[itemIndex] = {
                                            ...item,
                                            link_url: e.target.value,
                                          };
                                          handleContentChange(
                                            section.id,
                                            content.id,
                                            'list',
                                            JSON.stringify(newList)
                                          );
                                        }
                                      }}
                                      placeholder="https://example.com"
                                      disabled={!isEditing}
                                      variant={
                                        isEditing ? 'outlined' : 'standard'
                                      }
                                    />
                                  )}
                                </Box>
                              )}
                            </Box>
                          ))}
                        </Box>
                      ) : null}
                    </Box>
                  ))}
                </Box>
              ))
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary" gutterBottom>
                  No Content Sections Available
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  This newsfeed doesn't have any content sections yet.
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    bgcolor: 'grey.100',
                    borderRadius: 1,
                    textAlign: 'left',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="pre"
                    sx={{ fontSize: '0.8rem', overflow: 'auto' }}
                  >
                    Debug Info: sections ={' '}
                    {JSON.stringify(currentData?.sections, null, 2)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Paper>
        </Grid>

        {/* Right Column - Metadata */}
        <Grid item xs={12} lg={4}>
          <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Metadata
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Created Date
                </Typography>
                <Typography variant="body1">
                  {new Date(currentData?.created_at || '').toLocaleDateString()}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Status
                </Typography>
                <Chip
                  label={currentData?.is_active ? 'Active' : 'Inactive'}
                  color={currentData?.is_active ? 'success' : 'default'}
                  size="small"
                  icon={<ViewIcon />}
                />
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Start Date
                </Typography>
                <Typography variant="body1">
                  {currentData?.start_date
                    ? new Date(currentData.start_date).toLocaleDateString()
                    : 'Not set'}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  End Date
                </Typography>
                <Typography variant="body1">
                  {currentData?.end_date
                    ? new Date(currentData.end_date).toLocaleDateString()
                    : 'Not set'}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Scope
                </Typography>
                <Typography variant="body1">
                  {currentData?.is_international
                    ? 'International'
                    : 'Chapter-specific'}
                </Typography>
              </Box>
              {currentData?.local_chapter_id && (
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Local Chapter
                  </Typography>
                  <Typography variant="body1">
                    {currentData.local_chapter_id}
                  </Typography>
                </Box>
              )}
              {currentData?.spd_chapter_id && (
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    SPD Chapter
                  </Typography>
                  <Typography variant="body1">
                    {currentData.spd_chapter_id}
                  </Typography>
                </Box>
              )}
              {currentData?.image_url && (
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Preview Image
                  </Typography>
                  <img
                    src={currentData.image_url}
                    alt="Newsfeed preview"
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                    }}
                  />
                </Box>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete "{newsfeed.title}"? This action
            cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowDeleteDialog(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color="error"
            variant="contained"
            disabled={isDeleting}
            startIcon={
              isDeleting ? <CircularProgress size={20} /> : <DeleteIcon />
            }
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
